import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * Returns the currency symbol configured in the admin settings.
 * Falls back to "₹" while loading or on error.
 */
export function useCurrencySymbol() {
  const { data } = useQuery({
    queryKey: ["public-config"],
    queryFn: async () => (await api.get("/config")).data,
    staleTime: 5 * 60 * 1000, // cache for 5 minutes
  });
  return data?.currency_symbol ?? "₹";
}
